import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    listLoading: false,
    exportLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: []
}

export const callTypes = {
    list: "list",
    action: "action"
};

export const AddContestUserSlice = createSlice({
    name: "addContestsUser",
    initialState: initialState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        contestUserList: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
        },
        emptyList: (state, action) => {
            state.error = null;
            state.entities = [];
            state.totalCount = 0;
        },
    }
})